"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatWeekNumberHeader = formatWeekNumberHeader;
/**
 * Formats the header for the week number column.
 *
 * @defaultValue An empty string `""`.
 * @returns The formatted week number header as a string.
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */
function formatWeekNumberHeader() {
    return ``;
}
